import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';


@JsonObject('model.TemporaryVariable')
export class TemporaryVariable extends AbstractModel {

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(String, 'description')
	description?: string;
}
